import { render, staticRenderFns } from "./borderUpdateCom.vue?vue&type=template&id=c3d32708&scoped=true"
import script from "./borderUpdateCom.vue?vue&type=script&lang=js"
export * from "./borderUpdateCom.vue?vue&type=script&lang=js"
import style0 from "./borderUpdateCom.vue?vue&type=style&index=0&id=c3d32708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d32708",
  null
  
)

export default component.exports